import { PlaceFootfall, PlacesByBrandRequest, PlacesByCategoriesRequest } from 'src/common-services/types/places-types'
import { BaseClient } from 'src/common-services/clients/base-client'
import { BrandedPlace } from 'src/server/data/places-data'

export class PlacesClient extends BaseClient {
  trends(placekey: string, start: string, end: string) {
    const path = `/places/${placekey}/foot-traffic`
    return this.get<PlaceFootfall[] | undefined>(path, { start, end })
  }
  getByBrand(request: PlacesByBrandRequest): Promise<BrandedPlace[]> {
    return this.post('/places/by-brand', request)
  }
  getByCategories(request: PlacesByCategoriesRequest): Promise<BrandedPlace[]> {
    return this.post('/places/by-categories', request)
  }
}
